module.exports = __webpack_public_path__ + "fonts/fa-solid-900.cbd5928.ttf";